module.exports = __webpack_public_path__ + "static/media/FigmaSetTokenConfig.c1233384.png";